export default __webpack_public_path__ + "static/info-f7fdd7154e643798697dafe2f4e6a66b.svg";